import { render } from "./FpFlipBook.vue?vue&type=template&id=7225e4c4&scoped=true"
import script from "./FpFlipBook.vue?vue&type=script&lang=js"
export * from "./FpFlipBook.vue?vue&type=script&lang=js"

import "./FpFlipBook.vue?vue&type=style&index=0&id=7225e4c4&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7225e4c4"]])

export default __exports__